import { ReportPeriod, ReportType } from "@/components/common/report-chip";

export interface ParsedDsdMeta {
  year?: number;
  type?: ReportType;
  period?: ReportPeriod;
}

// ============================================
// DSD 파일명에서 표시용 메타(유형/연도/기간)를 추정한다.
// 예: "20260630_코메론_사업보고서(연결)_v2.dsd" → { year:2026, type:CONSOLIDATED, period:Q4 }
// 어디까지나 업로드 전 미리보기용 추정이며, 확정 값은 분석 후 백엔드가 정한다.
// ============================================

export const parseDsdFilename = (filename: string): ParsedDsdMeta => {
  const name = filename.replace(/\.dsd$/i, "");

  const yearMatch = name.match(/20\d{2}/);
  const year = yearMatch ? Number(yearMatch[0]) : undefined;

  const type: ReportType | undefined = /\(?연결\)?/.test(name)
    ? "CONSOLIDATED"
    : /\(?별도\)?/.test(name)
      ? "SEPARATE"
      : undefined;

  const period: ReportPeriod | undefined = /반기/.test(name)
    ? "Q2"
    : /(3분기|3Q|Q3)/i.test(name)
      ? "Q3"
      : /(1분기|1Q|Q1)/i.test(name)
        ? "Q1"
        : /사업/.test(name)
          ? "Q4"
          : undefined;

  return { year, type, period };
};
